import styled from 'styled-components';
import shadeColor from './../utilities/shadeColor';

const ListRow = styled.div`

    width: calc(100% - 10px);
    background-color: #ffffff;
    border-radius: 5px;
    margin: 5px;

    input[type='radio'] {
        display: none;
    }
    label {
        position: relative;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        :hover {
            .rowTitle{
                border: 1px solid ${props => props.borderColor
                    ? shadeColor(props.borderColor, 0.5)
                    : '#a7c1d7'
                };
                padding: 6.5px;
            }
        }
        .rowTitle {
            cursor: pointer;
            border: 1px solid #ebebeb;
            border-radius: 5px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 6.5px;
        }
    }
    input[type='radio']:checked+label>.rowTitle {
        border: 1.5px solid ${props => props.borderColor || '#265a9c'};
        box-shadow: 0 1px 3px rgba(0,0,0, 0.3);
        padding: 6px;
    }
`;

export default ListRow;


// WEBPACK FOOTER //
// ./src/components/ListRow.jsx